// extracted by mini-css-extract-plugin
export default {"root":"dL4IhZ1G","title":"BbuvuktW","subtitle":"Vuw6vs70","listItem":"TZu7zCZW","deviceInfo":"QDMOeZN6","currentBadge":"J4xcEefT","removeButton":"TsYToIsU"};